import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrapPlugin from "@fullcalendar/bootstrap5";
import axios from "axios";

export default function (defaultDate, calendarLocale, themeSystem = 'standard') {
    return {
        plugins:         [dayGridPlugin, bootstrapPlugin],
        themeSystem:     themeSystem,
        initialView:     'dayGridMonth',
        height:          'auto',
        firstDay:        1,
        headerToolbar:   {
            left:   '',
            center: 'prev title next',
            right:  ''
        },
        dayMaxEventRows: 2,
        moreLinkContent: TABS.$t('flere'),
        defaultDate:     defaultDate,
        visibleRange:    {
            start: new Date(),
        },
        locale:          calendarLocale,
        eventSources:    [
            {
                events: TABS.calendar.debounceEventSource('calendar-events', (fetchInfo, successCallback, failureCallback) => {
                    const data = TABS.calendar.filter
                    if (!data.product_id) {
                        successCallback([]);
                        return
                    }
                    data.start = fetchInfo.startStr;
                    data.end = fetchInfo.endStr;
                    return axios.post(TABS.api.getHost() + '/calendar/events/', data, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                        .then(function (response) {
                            successCallback(response.data)
                        }).catch(function (xhr) {
                            failureCallback('Request failed: ' + xhr.statusText);
                        })
                })
            }
        ],
    }
}